import { patientActions, noteActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        var tabs = {};

        Object.values(action.payload.entities.patients).forEach(x => {
            tabs['HOME_' + x.id] = {
                id: 'HOME_' + x.id,
                type: 'HOME',
                ptno: x.id
            };
        });
        state = { ...state, ...tabs };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        return { ...state, ...action.payload.ui.patientTabs };
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.openPdfRequest]: (state, action) => {
        var tab = {
            id: 'PDF_' + action.payload.noteId,
            noteId: action.payload.noteId,
            type: 'PDF',
            ptno: action.payload.ptno,
            noteSource: action.payload.noteSource,
            docRenderType: action.payload.docRenderType === undefined ? 1 : action.payload.docRenderType,
        }
        state[tab.id] = tab;
    },
    [patientActions.openAlRequest]: (state, action) => {
        var tab = {
            id: 'AL_' + action.payload.epno,
            type: 'AL',
            ptno: action.payload.ptno
        }
        state[tab.id] = tab;
    },
    [patientActions.closeTab]: (state, action) => {
        delete state[action.payload.tabId];
    },
    [noteActions.openInProgNoteRequest]: (state, action) => {
        var tab = {
            id: 'IN_' + action.payload.noteId,
            type: 'IN',
            noteId: action.payload.noteId,
            ptno: action.payload.ptno
        }
        state[tab.id] = tab;
    },
    [noteActions.deleteNoteSuccess]: (state, action) => {
        delete state['IN_' + action.payload];
    },
    [noteActions.startBlankEvalSuccess]: (state, action) => {
        var tab = {
            id: 'IN_' + action.payload.noteId,
            type: 'IN',
            noteId: action.payload.noteId,
            ptno: action.payload.ptno
        }
        state[tab.id] = tab;
    },
    [noteActions.transferEvalSuccess]: (state, action) => {
        // var tab = {
        //     id: 'IN_' + action.payload.noteId,
        //     type: 'IN',
        //     noteId: action.payload.noteId,
        //     ptno: action.payload.ptno
        // }
        // state[tab.id] = tab;
    },
    [noteActions.prepopulateEvalSuccess]: (state, action) => {
        var tab = {
            id: 'IN_' + action.payload.noteId,
            type: 'IN',
            noteId: action.payload.noteId,
            ptno: action.payload.ptno
        }
        state[tab.id] = tab;
    },

})


